export const menuArr = [
  { name: '推荐', benefit_type: 4 },
  { name: '娱乐', benefit_type: 6 },
  { name: '生活', benefit_type: 5 },
  { name: '购物', benefit_type: 7 }
];
